import axios from 'axios';

const ownershipTransferApi = '/teslaaccount/ownership/transfer/api';
const defaultHeader = token => {
  return {
    headers: {
      'CSRF-Token': token,
    },
  };
};

export const addCarEligibilityApi = (csrfToken, data) => {
  return axios.post(`${ownershipTransferApi}/add-car-eligibility`, data, defaultHeader(csrfToken));
};

export const addCarUploadDocumentsApi = (csrfToken, formData) => {
  return axios.post(
    `${ownershipTransferApi}/upload-approved-document`,
    formData,
    defaultHeader(csrfToken)
  );
};

export const addCarProcessApi = (csrfToken, data) => {
  return axios.post(`${ownershipTransferApi}/add-car-process`, data, defaultHeader(csrfToken));
};

export const getSignedToken = data => axios.post(`${ownershipTransferApi}/signed-token`, data);

export const getUserSignedToken = () => axios.get(`${ownershipTransferApi}/get-signed-user-token`);

export const fetchBillingAddress = () => axios.get(`${ownershipTransferApi}/get-billing-address`);

export const removeCarRequestApi = (csrfToken, data) => {
  return axios.post(`${ownershipTransferApi}/remove-car`, data, defaultHeader(csrfToken));
};

export const confirmTransferRequestApi = (csrfToken, data) => {
  return axios.post(`${ownershipTransferApi}/confirm-transfer`, data, defaultHeader(csrfToken));
};

export const getCNLocationListApi = () => {
  const uri = '/cua-api/drive/country-data?locale=zh_CN&additional=true';
  return axios.get(uri);
};

export const getSvgCaptcha = () => {
  const uri = '/teslaaccount/ownership/transfer/api/captcha';
  return axios.get(uri);
};

export const updateBillingAddress = data =>
  axios.post(`/teslaaccount/charging/api/save-billing-address`, data);
